<template>
  <div>
    <div
      class="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3 border-bottom"
    >
      <h1 class="h2 text-muted">ADMINISTRATION / USER ACCOUNTS</h1>
      <button
        type="button"
        class="btn btn-primary"
        @click="$router.push('/addUser')"
        id="but"
      >
        Add User
      </button>
    </div>
    <table class="table">
      <thead>
        <tr>
          <th scope="col">#</th>
          <th scope="col">Username</th>
          <th scope="col">Full Name</th>
          <th scope="col">Email</th>
          <th scope="col">Status</th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="user in users"
          :key="user.UserId"
          @click="edit(user.user_id)"
          class="clickable-row"
        >
          <td class="count"></td>
          <td>{{ user.username }}</td>
          <td>{{ user.full_name }}</td>
          <td>{{ user.email }}</td>
          <td v-if="user.active">Active</td>
          <td v-else>Disabled</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
// import axios from "axios";
import config from "../../config";
export default {
  data() {
    return {
      users: [],
    };
  },
  methods: {
    edit(id) {
      this.$router.push("/edituser/" + id);
    },
  },
  async mounted() {
    const response = await fetch(config.baseURL + "/get_users", {
      credentials: "include",
    });
    const data = await response.json();
    console.log(data);
    this.users = data;
  },
};
</script>

<style scoped>
.h2 {
  display: inline;
}
#but {
  display: inline;
  float: right;
}
.clickable-row {
  cursor: pointer;
}
table {
  counter-reset: section;
}
.count:before {
  counter-increment: section;
  content: counter(section);
}
</style>
